import axios from 'axios';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api` : 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
  withCredentials: true
});

// Helper to get CSRF token
export const refreshCsrfToken = async () => {
  try {
    const response = await instance.get('/csrf/csrf-token');
    const { csrfToken } = response.data;
    instance.defaults.headers.common['X-CSRF-Token'] = csrfToken;
    return csrfToken;
  } catch (error) {
    console.error('Failed to fetch CSRF token:', error);
    return null;
  }
};

// Add interceptor to retry once on CSRF failure
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 403 && error.response?.data === 'invalid csrf token' && !originalRequest._retry) {
      originalRequest._retry = true;
      const newToken = await refreshCsrfToken();
      if (newToken) {
        originalRequest.headers['X-CSRF-Token'] = newToken;
        return instance(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
